export const SAVE_BUTTON_CLICK = 'CpsrLoadTemplateModal/SAVE_BUTTON_CLICK';
